import loadergif from "../src/components/images/loader.gif";
export default global.config = {
    
    gvr: {
        ErrMsgs: {
            Comp_Name: "K&N's Poultry Farms",
            TitleNotFound:"Warning",
            MsgNotFound: "Sorry, No record found...",
            TitleNotLoggedin:"Not loggedin",
            MsgNotLoggedin:"Sorry, you are not logged in OR your login session has been expired.",
            TitleUnknown:"Unknown error",
            MsgUnknown:"Some error occoured. Please try later after few moments...",
            TitleSuccess:"Successfull",
            MsgSuccess:"Process completed successfully...",
            TitleAuthorised:"Not authorisded",
            MsgAuthorised:"Only authorised person have this feature..."

        },
        mymodal:{modalTitle:"",delSuccess:"Record has been deleted.",saveSuccess:"Record has been saved.",modalImage:{loadergif},
                    updateSuccess:"Record has been updated.",loadwait:"Wait please...",error:"There might be some internal errors to complete the requested. Please try later.",
                    footerClose:"<button onClick={this.hideModal}>Close</button>",footerCancel:"<div><button onClick={() => {this.handledelete(recid,i)}}>Confirm</button><button onClick={this.hideModal}>Cancel</button></div>",
                    modalsm:"sm",modallg:"lg"
        }
    },
    changeDivClass:"container12",
    Newsarray:[],
    Newsarraycount:0,
//    Appdir:"https://"+document.location.hostname+"/hr"
Appdir:"https://poultry-kandns.com/hr",

//    Appdir:"https://poultry-kandns.com/hr",
    Appdirabt:"https://poultry-kandns.com/hr-abt",
    Appdirgp:"https://poultry-kandns.com/hr-gp"
};